<template>
  <el-dialog
    title="内容编辑"
    align="center"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    fullscreen
  >
    <div class="editor" style="border: 1px solid #ccc;">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        style="height: 500px; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Vue from "vue";
import API from "@/api";
import local from "@/utils/localStroage";
import baseConfig from "@/utils/serverUrlConfig";
import FormatPaintMenuConf, { withSelect } from "@/assets/FormatPaint.js";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { Boot } from "@wangeditor/editor";
import SparkMD5 from "spark-md5";
Boot.registerMenu(FormatPaintMenuConf);
Boot.registerPlugin(withSelect);
export default Vue.extend({
  components: { Editor, Toolbar },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      chunk_size: "2048000", //分片大小
      totalProgress: {}, //总进度
      requestAll: [], //总请求
      requestNum: 0, //正在请求的数量
      requestMaxNum: 6, //同时最大请求数量
      sendVideoSucNum: 0, //分片上传视频，成功收到的返回
      uploadStatue: {
        statusText: "上传中,请勿退出",
        percent: 0, //当前上传文件执行的百分比
      },
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      dialogVisible: false,
      editor: null,
      html: "",
      toolbarConfig: {
        insertKeys: {
          index: 5, // 插入的位置，基于当前的 toolbarKeys
          keys: ["FormatPaintMenuConf"],
        },
      },
      editorConfig: {
        placeholder: "请输入内容...",
        hoverbarKeys: {
          text: {
            menuKeys: [
              "headerSelect",
              "insertLink",
              "bulletedList",
              "|",
              "bold",
              "through",
              "color",
              "bgColor",
              "FormatPaintMenuConf",
              "clearStyle",
            ],
          },
        },
        MENU_CONF: {
          //配置上传图片
          uploadImage: {
            // 自定义上传图片 方法
            customUpload: this.uploadImg,
            // 自定义插入图片 方法
            // customInsert: this.insertImg,
            //server必须要配置正确,我这里因为上传图片有点特殊，在下面方法配置了，所以此处不用配置地址
            server: baseConfig.baseServerUrl + "/vid/uploadStatic",
            // maxFileSize: 4 * 1024 * 1024, // 1M
            // 最多可上传几个文件，默认为 100
            // maxNumberOfFiles: 100,
            // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
            allowedFileTypes: ["image/*"],
            // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
            fieldName: "upload",
            meta: {
              //官网中把token放到了这里，但是请求的时候会看不到token
            },
            headers: {
              Authorization: local.get("userInfo").token,
              //所以token放这里
              // token: window.sessionStorage.token,
            },
            // 将 meta 拼接到 url 参数中，默认 false
            metaWithUrl: false,
            // 跨域是否传递 cookie ，默认为 false
            withCredentials: false,
            // 超时时间，默认为 10 秒
            timeout: 5 * 1000, // 5 秒
          },
          // 配置上传视频（同上传图片）
          uploadVideo: {
            customUpload: this.uploadVideo,
          },
        },
      },
      mode: "default", // or 'simple'
    };
  },
  methods: {
    open(content) {
      let str = content;
      this.html = str.replace(/<img.*?src=['"]/g, `<img src="${this.imgUrl}`)
      // console.log(this.html)
      // this.html = content
      // console.log(content)
      this.dialogVisible = true;
    },
    onCreated(editor) {
      // console.log(editor)
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    // 上传图片
    uploadImg(file, insertFn) {
      let imgData = new FormData();
      imgData.append("upload", file);
      // console.log(imgData);
      API.uploadImg(imgData)
        .then((res) => {
          // console.log(res);
          if (res.code === 200) {
            insertFn(this.imgUrl + res.data.coverImg);
            this.$message({
              message: "上传图片成功！",
              type: "success",
            });
          } else {
            this.$message.error("上传图片失败！");
          }
        })
        .catch(() => {});
    },
    // 上传视频
    async uploadVideo(file, insertFn) {
      // console.log(file);
      const fileMd5 = await this.fileReaderPromisify(file);
      let file_chunks = this.getFileChunks(file);

      let length = file_chunks.length;
      for (let index in file_chunks) {
        let chunk = file_chunks[Number(index)];
        // console.log(chunk, '----------------');
        let opts = {
          pos: Number(index) + 1,
          totalPos: length,
          data: Buffer.from(await chunk.arrayBuffer(), "utf8").toString(
            "base64"
          ),
          id: fileMd5,
        };
        // state.uploadData.md5 = fileMd5;
        this.requestAll.push(opts);
      }
      this.requestConcurrency(insertFn);
      // console.log(fileMd5);
      // console.log(length);
    },
    // 开始上传
    async upload(options, insertFn) {
      try {
        this.requestNum++;
        let callback = (processCallback) => {
          let percent = parseInt(
            ((processCallback.loaded / processCallback.total) * 100).toString()
          );
          this.totalProgress[options.pos - 1] = percent.toFixed(2);
          let strArr = Object.values(this.totalProgress);
          let numberArr = strArr.map(Number);
          this.uploadStatue.percent = Number(
            this.average(numberArr).toFixed(1)
          );
        };
        let ret = await API.uploadDotJson(options, callback);
        this.sendVideoSucNum++;
        if (this.uploadStatue.percent == 100) {
          // 所有分片请求发送完毕，等待返回
          this.uploadStatue.statusText = "处理中，请勿退出";
        }
        if (this.sendVideoSucNum == options.totalPos) {
          // console.log(ret, "--------------");
          this.uploadStatue.statusText = "上传成功";
          insertFn(
            baseConfig.baseServerUrl +
              baseConfig.playVideoUrl +
              ret.data.sourceURL +
              "?token=" +
              this.token
          );
          // this.uploadData.sourceURL = ret.videoUri;
          // this.uploadData.sourceID = ret.id;
          // emit("uploadVideoSuccess", this.uploadData);
          return;
        }
      } catch (e) {
        this.currentRate = 0;
        this.uploadStatue.percent = 0;
        this.uploadStatue.statusText = "上传失败";
        this.sendVideoSucNum = 0;
        // console.log('失败---' + e)
      } finally {
        this.requestNum--;
        this.requestConcurrency(insertFn);
      }
    },
    // 平均数
    average(nums) {
      return nums.reduce((a, b) => a + b) / nums.length;
    },
    requestConcurrency(insertFn) {
      // console.log("上传");
      while (
        this.requestAll.length > 0 &&
        this.requestNum <= this.requestMaxNum &&
        this.requestNum >= 0
      ) {
        // console.log("上传");
        let opts = this.requestAll.shift();
        this.upload(opts, insertFn);
      }
    },
    // 将视频分片
    getFileChunks(file) {
      let { size } = file;
      let total_chunks = Math.ceil(size / this.chunk_size);
      let file_chunks = [];
      if (size > this.chunk_size) {
        for (let i = 0; i < total_chunks; i++) {
          let start = i * this.chunk_size;
          let end = (i + 1) * this.chunk_size;
          let chunk = file.slice(start, end);
          this.totalProgress[i] = 0;
          file_chunks.push(chunk);
        }
      } else {
        file_chunks.push(file);
        this.totalProgress[0] = 0;
      }
      return file_chunks;
    },
    fileReaderPromisify(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let Spark = new SparkMD5.ArrayBuffer();
        reader.readAsArrayBuffer(file);
        reader.onload = function(e) {
          Spark.append(e.target.result);
          let md5 = Spark.end();
          resolve(md5);
        };
        reader.onerror = (err) => {
          reject(err);
        };
      });
    },
    handleClose() {
      this.html = "";
      this.dialogVisible = false;
    },
    onSubmit() {
      let str = this.html.replaceAll(this.imgUrl, '')
      // console.log(str);
      this.$emit('setContent', str)
      this.dialogVisible = false;
    }
  },
});
</script>

<style></style>
